<template>
 <div>
   <div v-if="videos.length > 0" class="embed-responsive embed-responsive-16by9">
      <div class="embed-responsive-item videoWrapper">
        <job-video-wrapper :entityList="videos" :jobId="manifest.manifestId"></job-video-wrapper>
      </div>
   </div>
   <div v-else-if="thumbs.length > 0">
     <b-carousel
      id="carousel-1"
      :interval="0"
      controls
      v-if="thumbs.length > 0">
      <b-carousel-slide v-for="url in thumbs" :key="url" :img-src="url" class="rounded-0" alt="Media Thumb" ></b-carousel-slide>
    </b-carousel>
   </div>
   <div v-else class="text-center pt-4 no-media">
     No Preview
   </div>
 </div>
</template>

<script>

import { entityThumbURLs, filterEntitiesByVideoOnly } from '#/models/entities/entity';
import { EntityGetSession } from '#/services/entities';
import { EntityId } from '#/protobuf/general_pb';
import JobVideoWrapper from '#/ui/Components/Jobs/JobVideoWrapper.vue';

export default {
  components: {
    JobVideoWrapper,
  },
  props: {
    manifest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      entities: [],
      allIds: [],
    };
  },
  created() {
    const { jobsList } = this.manifest;
    jobsList.forEach((job) => {
      const derivs = job.expandedMediaDerivativesList;
      console.info(derivs.length);
      if (derivs.length === 0) {
        return;
      }
      derivs.forEach((d) => {
        const { size } = d.output;
        const checksum = d.output.checksums.xxhash3128;
        const entityId = new EntityId();
        entityId.setSize(size);
        entityId.setChecksum(checksum);
        this.allIds.push(entityId);
      });
    });

    if (this.allIds.length > 0) {
      console.info('loading job media...', this.allIds.length);
      const session = new EntityGetSession(this.allIds);
      session.load().then((result) => {
        this.entities = result.toObject().entitiesList;
        console.log('loaded job media', this.entities);
      }).catch((error) => {
        console.warn('caught error getting job media', error);
      });
    }
  },
  computed: {
    name() {
      // properly make sure this stays as one row. and doesn't trigger overflow into a second row
      let name = this.entity.name ? this.entity.name : '(No Name)';
      if (name.length > 15) {
        name = `${name.substring(0, 15)}...`;
      }
      return name;
    },
    thumbs() {
      console.log('number of thumbs ', this.entities.length);
      return entityThumbURLs(this.entities);
    },
    videos() {
      console.log('number of videos', this.entities.length);
      return filterEntitiesByVideoOnly(this.entities);
    },
  },
  methods: {
    openFile() {
      const path = `/files/${this.entity.size}/${this.entity.checksum}`;
      console.info('opening file:', path);
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>

</style>
